// extracted by mini-css-extract-plugin
export default {"tariffs-table":"ShopTariffsTable_tariffs-table__IUSGr","booked":"ShopTariffsTable_booked__zFyfY"};